import React, { cloneElement } from "react";
import { Box, Button } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import theme from "theme";

export interface HitsBrowserLayoutProps {
  banner: React.ReactElement;
  control: React.ReactElement;
  document: React.ReactElement;
  hideDoc: boolean;
}
const HitsBrowserLayout = (props: HitsBrowserLayoutProps) => {
  const { banner, control, document, hideDoc } = props;

  const mobileDocument = cloneElement(document, {
    ...document.props,
    ...{
      className: {
        display: theme.breakpoints.only("xs") ? "none!important" : "block",
      },
    },
  });
  return (
    <Box
      sx={{
        display: "grid",
        gridAutoColumns: "1fr",
        gridTemplateColumns: hideDoc ? "1fr" : "minmax(400px, 500px) minmax(60%, 1fr)",
        gap: hideDoc ? "0px 0px" : "0px 16px",
        paddingTop: theme.spacing(1),
        width: "100%",
        flex: "1",
        pt: 2,
        minHeight: 0,
        [theme.breakpoints.only("xs")]: {
          gridTemplateColumns: "1fr",
          gap: "0px 0px",
        },
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}>
        {banner}
        {control}
      </Box>
      {!hideDoc && <Box sx={{ minHeight: 0, minWidth: 0 }}>{mobileDocument}</Box>}
    </Box>
  );
};

export interface NavButtonProps {
  dir: "next" | "previous";
  disabled: boolean;
  onClick: () => void;
}

export const NavButton = (props: NavButtonProps) => {
  return (
    <Button
      color="default"
      disabled={props.disabled}
      size="large"
      fullWidth
      style={{ height: "30px" }}
      onClick={() => props.onClick()}>
      {props.dir}
      {props.dir === "next" ? <ArrowDropDownIcon fontSize="large" /> : <ArrowDropUpIcon fontSize="large" />}
    </Button>
  );
};

export default HitsBrowserLayout;
